import React from "react";

import { Type } from "~/models/dto";

import { useNavigateToLink } from "../../../components/react/link";
import { useQueryNodeById } from "../../../queries";
import { MONITORS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export interface MonitorCreateBreadcrumbProps {
	monitorFunctionIdentifier: string;
}

export const MonitorCreateBreadcrumb: React.FC<MonitorCreateBreadcrumbProps> = ({ monitorFunctionIdentifier }) => {
	const linkToCreateMonitor = useNavigateToLink(MONITORS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
		params: { id: "new", monitorFunctionIdentifier },
	});

	const {
		isLoading,
		error,
		data: monitorFunction,
	} = useQueryNodeById(Type.MonitorFunction, monitorFunctionIdentifier, {
		refetchOnWindowFocus: false,
	});

	if (isLoading) {
		return <BreadcrumbLayout label="" />;
	}

	if (error || monitorFunction == null) {
		return <BreadcrumbLayout label="Monitor type not found" />;
	}

	return <BreadcrumbLayout label={`${monitorFunction.name} monitor`} to={linkToCreateMonitor} />;
};
